interface Header {
  name: string;
  key: string;
  align: 'left' | 'right';
  ariaLabel?: string;
}

export const getColumnHeaders = (
  showPreRetirementColumn: boolean,
  showPostRetirementColumn: boolean,
): Header[] => {
  const baseColumns: Header[] = [
    {
      name: 'Type',
      key: 'type',
      align: 'left',
    },
  ];

  const preRetirementColumn: Header = {
    name: showPostRetirementColumn ? 'Pre-Retirement Amount' : 'Amount',
    key: 'amount',
    align: 'right',
  };

  const postRetirementColumn: Header = {
    name: 'In Retirement Amount',
    key: 'postRetirementAmount',
    align: 'right',
  };

  const actionColumn: Header = {
    name: '',
    key: 'actions',
    align: 'right',
    ariaLabel: 'Actions',
  };

  return [
    ...baseColumns,
    ...(showPreRetirementColumn ? [preRetirementColumn] : []),
    ...(showPostRetirementColumn ? [postRetirementColumn] : []),
    actionColumn,
  ];
};
